'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _headings = require('./headings');

Object.defineProperty(exports, 'headings', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_headings).default;
  }
});

var _text = require('./text');

Object.defineProperty(exports, 'text', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_text).default;
  }
});

var _fontFamilies = require('./fontFamilies');

Object.defineProperty(exports, 'fontFamilies', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fontFamilies).default;
  }
});

var _paragraph = require('./paragraph');

Object.defineProperty(exports, 'paragraph', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_paragraph).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS90eXBvZ3JhcGh5L2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzZDQUFTQSxPOzs7Ozs7Ozs7eUNBQ0FBLE87Ozs7Ozs7OztpREFDQUEsTzs7Ozs7Ozs7OzhDQUNBQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBoZWFkaW5ncyB9IGZyb20gJy4vaGVhZGluZ3MnXG5leHBvcnQgeyBkZWZhdWx0IGFzIHRleHQgfSBmcm9tICcuL3RleHQnXG5leHBvcnQgeyBkZWZhdWx0IGFzIGZvbnRGYW1pbGllcyB9IGZyb20gJy4vZm9udEZhbWlsaWVzJ1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBwYXJhZ3JhcGggfSBmcm9tICcuL3BhcmFncmFwaCdcbiJdfQ==